import Http from '@/utils/http'
import { RequestType } from '@/typings/enum/Common'
import NLoginApi = global.NLoginApi

class GetTradeBackInfo extends Http {
  [x: string]: any
  public async getTradeBackInfo(data: NLoginApi.getTradeBackInfoRequestData) {
    return await super.request<NLoginApi.getTradeBackInfoResponse>({
      url: '/tradeback/info',
      method: RequestType.Post,
      headers: {
        'Content-Type': 'application/json'
      },
      data
    })
  }

  public async getExportTradeBackExcel(data: NLoginApi.getTradeBackInfoRequestData) {
    return await super.request<NLoginApi.getTradeBackInfoResponse>({
      url: '/tradeback/exportExcel',
      method: RequestType.Post,
      headers: {
        'Content-Type': 'application/json'
      },
      data,
      responseType: 'blob'
    })
  }

  public async getBankNames(data: NLoginApi.MultiBankRequestData) {
    return await super.request<NLoginApi.MultiBankResponse>({
      url: '/crossbowSystem/getAllBankNames',
      method: RequestType.Post,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      data
    })
  }

  public async getBankLevels(data: NLoginApi.BankLevelsRequestData) {
    return await super.request<NLoginApi.BankLevelsResponse>({
      url: '/crossbowSystem/getAllBankLevels',
      method: RequestType.Post,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      data
    })
  }

  public async getObscureSceneId(data: NLoginApi.obscureSceneIdRequestData) {
    return await super.request<NLoginApi.obscureSceneIdResponse>({
      url: '/tradeback/getSceneIds',
      method: RequestType.Post,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      data
    })
  }

  public async getPublicTextAccount(data: NLoginApi.getPublicTextAccountRequestData) {
    return await super.request<NLoginApi.getPublicTextAccountResponse>({
      url: '/crossbowSystem/publicTextAccount/list',
      method: RequestType.Post,
      headers: {
        'Content-Type': 'application/json'
      },
      data
    })
  }

  public async getExportPublicTextAccountExcel(data: NLoginApi.getPublicTextAccountRequestData) {
    return await super.request<NLoginApi.getPublicTextAccountResponse>({
      url: '/crossbowSystem/publicTextAccount/exportExcel',
      method: RequestType.Post,
      headers: {
        'Content-Type': 'application/json'
      },
      data,
      responseType: 'blob'
    })
  }

  public async updateShowFields(data: NLoginApi.updateShowFieldsRequestData) {
    return await super.request<NLoginApi.updateShowFieldsResponse>({
      url: '/crossbowSystem/updateShowFields',
      method: RequestType.Post,
      headers: {
        'Content-Type': 'application/json'
      },
      data
    })
  }

  public async exportPublicTextAccountExcel(data: NLoginApi.exportPublicTextAccountRequestData) {
    return await super.request<NLoginApi.exportPublicTextAccountResponse>({
      url: '/crossbowSystem/publicTextAccount/exportExcel',
      method: RequestType.Post,
      headers: {
        'Content-Type': 'application/json'
      },
      data,
      responseType: 'blob'
    })
  }

  public async getPublicTextAccountSceneIds(data: NLoginApi.obscureSceneIdRequestData) {
    return await super.request<NLoginApi.obscureSceneIdResponse>({
      url: '/crossbowSystem/publicTextAccount/getSceneIds',
      method: RequestType.Post,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      data
    })
  }
}

export default GetTradeBackInfo
